import { render } from "./FormInput.vue?vue&type=template&id=4c5abbd1"
import script from "./FormInput.vue?vue&type=script&lang=js"
export * from "./FormInput.vue?vue&type=script&lang=js"

import exportComponent from "/opt/microsoft-academy/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__